var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3548 25.1752C10.7775 25.1752 9.37096 23.8896 8.85562 21.9746L9.40228 21.8135C9.84929 23.466 11.0366 24.5786 12.3548 24.5786C13.673 24.5786 14.8603 23.466 15.3045 21.8135L15.8511 21.9746C15.3386 23.8896 13.9321 25.1752 12.3548 25.1752Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9381 22.1924H5.06441C4.53768 22.1924 4.07928 21.8941 3.83727 21.393C3.58672 20.8799 3.63228 20.2744 3.95401 19.8091L4.83663 18.5354C6.04668 16.7904 6.71007 14.6278 6.71007 12.4473V9.96255C6.71007 6.50837 9.30954 3.69849 12.5041 3.69849C15.6986 3.69849 18.2981 6.50837 18.2981 9.96255V10.9558C18.2981 14.0998 19.2576 17.2139 20.9972 19.7285L21.0513 19.8091C21.373 20.2744 21.4186 20.8799 21.168 21.393C20.9232 21.8941 20.4648 22.1924 19.9381 22.1924ZM12.5012 4.29506C9.61989 4.29506 7.27666 6.83648 7.27666 9.96255V12.4473C7.27666 14.7531 6.57341 17.0409 5.29503 18.8873L4.4124 20.161C4.2188 20.4414 4.19032 20.8113 4.34122 21.1245C4.48643 21.4198 4.75691 21.5958 5.06441 21.5958H19.9409C20.2484 21.5958 20.516 21.4198 20.6612 21.1215C20.8121 20.8083 20.7865 20.4414 20.5901 20.1581L20.536 20.0775C18.7252 17.4615 17.7258 14.2221 17.7258 10.9529V9.96255C17.7258 6.83648 15.3826 4.29506 12.5012 4.29506Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2152 2.50537H12.7846V3.99681H12.2152V2.50537Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.453 13.9743L19.9405 13.7148C20.4814 12.5395 20.7576 11.2748 20.7576 9.9623C20.7576 7.49843 19.7525 5.14792 17.9987 3.5133L18.3774 3.06885C20.2508 4.81384 21.327 7.32841 21.327 9.9623C21.327 11.3672 21.0338 12.7155 20.453 13.9743Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54614 13.9744C3.96532 12.7156 3.67206 11.3673 3.67206 9.96239C3.67206 7.31359 4.75968 4.78709 6.65305 3.03613L7.02888 3.48357C5.25794 5.12117 4.24149 7.48362 4.24149 9.96239C4.24149 11.2749 4.51767 12.5396 5.05863 13.7178L4.54614 13.9744Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8312 15.6538L22.3273 15.3764C23.1615 13.7179 23.6028 11.8446 23.6028 9.96244C23.6028 6.74093 22.3757 3.74909 20.1492 1.53579L20.5421 1.10327C22.8825 3.42992 24.1722 6.57687 24.1722 9.96244C24.1722 11.9431 23.7081 13.9088 22.8312 15.6538Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16753 15.6538C1.2906 13.9088 0.826508 11.9431 0.826508 9.96246C0.826508 6.60671 2.16468 3.36133 4.49936 1.06152L4.88943 1.49702C2.63731 3.71629 1.39594 6.72304 1.39594 9.96246C1.39594 11.8447 1.83726 13.7179 2.66863 15.3734L2.16753 15.6538Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8bda6eb9e99c2b16efe48adf1d230ce4.svg";
export { ForwardRef as ReactComponent };